import React from 'react';
import styled from 'styled-components';

import { PlaceholderText } from '@modules/layout/atoms';

const Root = styled.div`
    width: 100%;
    height: 100%;
`;

const IndexPage = (): React.ReactElement => {
    return (
        <Root>
            <PlaceholderText>StrategicClaimsMassArb HomePage</PlaceholderText>
        </Root>
    );
};

export { IndexPage };
